import * as React from "react";
import { cn } from "@/lib/utils";

const Alert = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement> & { variant?: "info" | "success" | "warning" | "destructive" }>(
  ({ className, variant = "info", ...props }, ref) => <div ref={ref} role="alert" className={cn(variant === "info" ? "info-panel" : `status-panel ${variant === "destructive" ? "danger" : variant}`, className)} {...props} />
);
Alert.displayName = "Alert";

const AlertTitle = ({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) => <strong className={cn("alert-title", className)} {...props} />;
const AlertDescription = ({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) => <p className={cn("alert-description", className)} {...props} />;

export { Alert, AlertTitle, AlertDescription };
